import { render, staticRenderFns } from "./AttributeStatistics.vue?vue&type=template&id=d2db355e&scoped=true&"
import script from "./AttributeStatistics.vue?vue&type=script&lang=js&"
export * from "./AttributeStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2db355e",
  null
  
)

export default component.exports